
export class HasMaintenanceTaskUserNotificationNotRead {

  constructor(
    public hasNotify?: number
  ) { }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/has-maintenance-task-notification-not-read.ts